import { computed } from 'vue';
import { useEnvironment } from './useEnvironment';
import RegionIcon from './../icons/RegionIcon.vue';
import WebappLogo from './../brand/WebappLogo.vue';
import StoreLogo from './../brand/StoreLogo.vue';

const ProductType = {
    Accounts: {
        logo: RegionIcon,
        iconProps: { state: true },
    },
    Web: {
        logo: WebappLogo,
        iconProps: { state: true },
    },
    Beta: {
        logo: WebappLogo,
        iconProps: { state: true },
    },
    Store: {
        logo: StoreLogo,
        iconProps: { state: true },
    },
    Pathfinder: {
        logo: RegionIcon,
        iconProps: { state: true },
    },
    AppleStore: {
        logo: RegionIcon,
        iconProps: { state: true },
    },
    PlayStore: {
        logo: RegionIcon,
        iconProps: { state: true },
    },
};

const SignInLinkType = {
    None: 'None',
    ExistingAccount: 'ExistingAccount',
    NewAccount: 'NewAccount',
    AcceptInvite: 'AcceptInvite',
};

let route, signInLinkCleared;

function toCamelCase(str) {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index == 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, '');
}

function toTitleCase(str) {
    return str.replace(/\w\S*/g, (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
}

export function initializeProduct(envConfig, currentRoute) {
    console.log(`Product initialized`);
    route = currentRoute;

    useEnvironment(envConfig);

    Object.keys(ProductType).forEach((key) => {
        const p = ProductType[key];
        const keyCamel = toCamelCase(key);
        p.name = key.toLowerCase();
        p.url = envConfig.url[keyCamel] || window.location.origin;
        console.log(`Initialized product`, p);
    });
}

export function useProduct() {
    const { config } = useEnvironment();

    if (!config.value || !route?.value) {
        throw new Error('Call initializeProduct() with your config and current route before attempting to useProduct.');
    }

    function getProductFromName(name, isUrlRequired) {
        const title = toTitleCase(name);
        const p = ProductType[toTitleCase(name)];
        if (!p) {
            throw new Error(`Product with name ${name} does not exist`);
        }
        if (isUrlRequired && !p.url) {
            throw new Error('Missing product url in environment config');
        }
        return p;
    }

    const inviteUid = computed(() => {
        return route.value?.query?.['inviteUid'];
    });

    const continueToProduct = computed(() => {
        return route.value?.query?.['continue'];
    });

    const continueToAccounts = computed(() => {
        return route.value?.query?.['continueToAccounts'];
    });

    function clearSignInLink() {
        signInLinkCleared = true;
    }

    const signInLink = computed(() => {
        let linkType = SignInLinkType.None;
        const mode = route.value?.query?.['mode'];
        if (!signInLinkCleared && mode === 'signIn') {
            const path = route.value?.path || '';
            if (path.includes('accept-invite')) {
                linkType = SignInLinkType.AcceptInvite;
            } else {
                const isNewAccount = route.value?.query?.['isNewAccount'] === 'true';
                linkType = isNewAccount ? SignInLinkType.NewAccount : SignInLinkType.ExistingAccount;
            }
        }
        return linkType;
    });

    const hasSignInLink = computed(() => {
        return !signInLinkCleared && signInLink.value !== SignInLinkType.None;
    });

    const product = computed(() => {
        let p;
        if (continueToProduct.value) {
            try {
                p = getProductFromName(continueToProduct.value, true);
            } catch (error) {
                console.error(`Failed to initialize product from url`, error);
            }
        }

        if (!p) {
            p = getProductFromName(config.value?.product, false);
        }
        console.log(
            `Product: ${p.name}, signInLink: ${signInLink.value}, continueToProduct: ${continueToProduct.value}, continueToAccounts: ${continueToAccounts.value}`,
        );
        return p;
    });

    return {
        product,
        inviteUid,
        signInLink,
        hasSignInLink,
        clearSignInLink,
        continueToProduct,
        continueToAccounts,

        ProductType,
        SignInLinkType,
    };
}
